import { OpenInNew } from "@mui/icons-material";
import { Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { fileBlobGet } from "../../../../services/api/file.js";

export default ({ plan }) => {
  const { t } = useTranslation();

  return (
    <Link to={{ pathname: fileBlobGet(plan.terms) }} target="_blank">
      <Button>
        {t("terms_and_conditions")}
&nbsp;
        <OpenInNew fontSize="inherit" />
      </Button>
    </Link>
  );
};
